export function getClickedMouseButton(event: JQuery.Event) {
  const isLeftMB = event.which === 1 || event.buttons === 1;
  const isMiddleMB = event.which === 2 || event.buttons === 3;
  if (isLeftMB) {
    return 'left';
  }
  if (isMiddleMB) {
    return 'middle';
  }
  return 'other';
}
